<template>
  <div>
    <footer
      v-if="user"
      class="brand-color text-light d-flex justify-content-center"
    >
      <section class="layout-social py-5">
        <!-- <router-link class="text-light px-2" to="/users" v-if="user">
          <font-awesome-icon
            class="layout-icon"
            :icon="{ prefix: 'fas', iconName: 'address-book' }"
          ></font-awesome-icon>
        </router-link> -->
        <!-- <router-link class="text-light px-2" to="/faq" v-if="user">
          <font-awesome-icon
            class="layout-icon"
            :icon="{ prefix: 'fas', iconName: 'question-circle' }"
          ></font-awesome-icon>
        </router-link> -->
        <!-- <a class="text-light px-2" href="/">
          <font-awesome-icon class="layout-icon" :icon="{ prefix: 'fab', iconName: 'twitter' }"></font-awesome-icon>
        </a>
        <a class="text-light px-2" href="/">
          <font-awesome-icon class="layout-icon" :icon="{ prefix: 'fab', iconName: 'facebook' }"></font-awesome-icon>
        </a>
        <a class="text-light px-2" href="/">
          <font-awesome-icon class="layout-icon" :icon="{ prefix: 'fab', iconName: 'github' }"></font-awesome-icon>
        </a>
        <a class="text-light px-2" href="/">
          <font-awesome-icon class="layout-icon" :icon="{ prefix: 'fab', iconName: 'flickr' }"></font-awesome-icon>
        </a> -->
      </section>
    </footer>
  </div>
</template>

<script>
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "olabfooter",
  // components: {
  //   FontAwesomeIcon
  // },
  props: ["user"]
};
</script>

<style scoped>
.layout-social .layout-icon {
  font-size: 2em;
}
</style>
